module.exports = __webpack_public_path__ + "static/img/Round-frame.12c06a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Round-frame.png
// module id = A4mE
// module chunks = 2